import { reactive } from "vue";
import { api } from "../api/client";

/**
 * What the signed-in person may do in each workspace (role plus exceptions), fetched once per
 * workspace so screens show only what works. The API enforces the same rules.
 */
interface Grant {
  memberId: string;
  role: string;
  permissions: string[];
}
const grants = reactive<Record<string, Grant | undefined>>({});
const pending = new Map<string, Promise<void>>();

export function loadPermissions(slug: string): Promise<void> {
  if (grants[slug]) return Promise.resolve();
  let p = pending.get(slug);
  if (!p) {
    p = api<Grant>(`/v1/c/${slug}/me`)
      .then((g) => {
        grants[slug] = g;
      })
      .catch(() => undefined)
      .finally(() => pending.delete(slug));
    pending.set(slug, p);
  }
  return p;
}

/** Reactive: false until the workspace's permissions arrive. */
export function can(slug: string, permission: string): boolean {
  if (!grants[slug]) void loadPermissions(slug);
  return grants[slug]?.permissions.includes(permission) ?? false;
}

/** Tests and sign-out start over. */
export function forgetPermissions(): void {
  for (const k of Object.keys(grants)) delete grants[k];
}
